/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Leonid Khramov
 */
import { connect } from "react-redux"
import React, { Component } from "react"
import { withRouter } from "react-router"

import * as act from "../actions/teams"
import passwordValidator from "password-validator"

import "./MemberSetupContainer.css"
import { PRIVACY_POLICY, TERMS_OF_USE } from "../../../util/links"
import TopBar from "../components/TopBar"
import TeamRoleSetter from "../components/TeamRoleSetter"
import { webApi } from "../../../lib/WebApi"
import { fullName2FirstLast } from "../../../util/helpers"
import { statAdminEvent } from "../../../util/analytics"
import * as localForage from "localforage"

import { TRCButton, TRCInput } from "../../../trace"
import { pageTitle } from "trux"
import generator from "generate-password"
import { Label } from "trux"

class MemberSetup extends Component {
    constructor(props) {
        super(props)
        this.state = {
            errors: [],
            editState: { fullName: "", password: "", password2: "" },
            roles: {},
            inviteInfo: null,
            teams: [],
        }

        this.onCompleteSetup = this.onCompleteSetup.bind(this)
        this.onPassword2Changed = this.onPassword2Changed.bind(this)
        this.onPasswordChanged = this.onPasswordChanged.bind(this)
        this.onUserFullNameChanged = this.onUserFullNameChanged.bind(this)
        this.onRolesUpdate = this.onRolesUpdate.bind(this)
        this.validator = new passwordValidator()
        this.validator.is().min(6).has().lowercase()
    }

    componentDidMount() {
        pageTitle("Member Invitation", "Settings - Member Invite")
    }

    caption(field, text) {
        const errors = this.state.errors
        if (!field) {
            if (errors.length > 0) return errors[0].error
            return ""
        }
        for (const error of errors) {
            if (error.field === field) {
                return error.error
            }
        }
        return text
    }

    errorClass(field) {
        const errors = this.state.errors
        if (!field && errors.length > 0) return "error"
        for (const error of errors) {
            if (error.field === field) {
                return "invalid"
            }
        }
        return ""
    }

    errorWithout(field) {
        let err = []
        for (const item of this.state.errors) {
            if (item.field !== field) {
                err.push(item)
            }
        }
        return err
    }

    shortenName(full) {
        if (!full) return ""
        if (full.length < 14) return full
        return `${full.substr(0, 6)}...${full.substr(-6, 6)}`
    }

    getRolesList() {
        console.log("getRolesList state.teams", this.state.teams)
        console.log("getRolesList state.roles", this.state.roles)
        let roles = this.state.roles

        let lst = this.state.teams.map((item) => {
            return {
                id: item.team_id,
                user_id: item.team_id,
                full_name: item.title,
                short_name: this.shortenName(item.title),
                is_coach: roles[item.team_id] === "coach",
                is_videographer: roles[item.team_id] === "manager",
                role: roles[item.team_id],
                link: null,
            }
        })

        console.log("getRolesList lst", lst)

        return lst
    }

    componentWillMount() {
        this.props.loadNav()
        this.props.loadTeams(this.props.divisionId, (err, teams) => {
            this.setState({ teams: teams ? teams : [] })
        })
        const wthis = this
        webApi.getInviteInfo(this.props.inviteId).then((data) => {
            if (data) {
                //if(data.invite_status !== "pending") {
                //statAdminEvent(this.props.divisionId, "invite-redirect", "member")
                //this.props.history.replace(`/tbd/settings/division/${this.props.divisionId}/teams`)
                //} else {
                if (!data.is_new_user) {
                    const state = wthis.state.editState
                    wthis.setState({
                        inviteInfo: data,
                        editState: Object.assign(state, {
                            fullName: `${data.first_name} ${data.last_name}`,
                        }),
                    })
                } else {
                    let pw = generator.generate({
                        length: 32,
                        numbers: true,
                        symbols: true,
                        lowercase: true,
                        uppercase: true,
                    })
                    wthis.setState({
                        inviteInfo: data,
                        editState: Object.assign(wthis.state.editState, {
                            password: pw,
                            password2: pw,
                        }),
                    })
                }
                //}
            }
        })
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.divisionId !== this.props.divisionId) {
            this.props.loadTeams(nextProps.divisionId, (err, teams) => {
                this.setState({ teams: teams ? teams : [] })
            })
        }
    }

    render() {
        const editState = this.state.editState
        const roles = this.getRolesList()
        let disabled = false
        let hiddenClass = ""
        if (this.state.inviteInfo && !this.state.inviteInfo.is_new_user) {
            disabled = true
            hiddenClass = "hidden"
        }
        console.log("MemberSetupContainer.render", "roles", roles)
        return (
            <div className="MemberSetup">
                <TopBar hideMenu />
                <div className="trace-container content">
                    <Label
                        marginTop="4"
                        type={Label.Type.Heading2}
                        content="Complete Setup"
                    />
                    <Label
                        marginBottom="4"
                        type={Label.Type.Body}
                        content="Please accept your invitation below."
                    />

                    <div className="areablock">
                        <Label
                            type={Label.Type.Heading4}
                            content="Your full name"
                        />
                        <TRCInput
                            type="text"
                            placeholder="Enter Full Name"
                            value={editState.fullName}
                            onChange={this.onUserFullNameChanged}
                            disabled={disabled}
                            error={this.caption("fullName")}
                        />
                    </div>

                    <div className={`password-area areablock ${hiddenClass}`}>
                        <h4>Your password</h4>
                        <TRCInput
                            type="password"
                            placeholder="Enter Desired Password"
                            value={editState.password}
                            onChange={this.onPasswordChanged}
                            error={this.caption("password")}
                        />
                        <TRCInput
                            type="password"
                            placeholder="Re-enter Password"
                            value={editState.password2}
                            onChange={this.onPassword2Changed}
                            error={this.caption("password")}
                        />
                    </div>

                    <div className={this.errorClass("roles")}>
                        <TeamRoleSetter
                            entries={roles}
                            title="Teams"
                            miniTitle="Your Roles"
                            description="For which team are you a coach or manager?"
                            onRoleChanged={this.onRolesUpdate}
                        />
                        <span className="error">{this.caption("roles")}</span>
                    </div>

                    <div className="bottom-buttons">
                        <TRCButton
                            className="trace-input"
                            onClick={this.onCompleteSetup}
                        >
                            Accept
                        </TRCButton>
                    </div>

                    <div className="subscript">
                        By signing up you agree to our{" "}
                        <a href={TERMS_OF_USE}>Terms of Service</a> and{" "}
                        <a href={PRIVACY_POLICY}>Privacy Policy</a>
                    </div>
                </div>
            </div>
        )
    }

    onUserFullNameChanged(e) {
        //const state = Object.assign({}, this.state.editState, {fullName: e.target.value});
        const state = Object.assign({}, this.state.editState, { fullName: e })
        this.setState({
            editState: state,
            errors: this.errorWithout("fullName"),
        })
    }

    onPasswordChanged(e) {
        //const state = Object.assign({}, this.state.editState, {password: e.target.value});
        const state = Object.assign({}, this.state.editState, { password: e })
        if (this.state.inviteInfo && !this.state.inviteInfo.is_new_user) {
            state.password2 = state.password
        }
        this.setState({
            editState: state,
            errors: this.errorWithout("password"),
        })
    }

    onPassword2Changed(e) {
        //const state = Object.assign({}, this.state.editState, {password2: e.target.value});
        const state = Object.assign({}, this.state.editState, { password2: e })
        this.setState({
            editState: state,
            errors: this.errorWithout("password2"),
        })
    }

    onCompleteSetup(e) {
        e.preventDefault()
        let errors = []
        const state = this.state.editState
        const roles = this.getRolesList()
        let roleCount = 0
        for (let role of roles) {
            console.log("onCompleteSetup role", role)
            if (role.role === "coach" || role.role === "manager") {
                roleCount++
            }
        }

        if (roleCount === 0) {
            errors.push({
                field: "roles",
                error: "You must select at least one role to continue",
            })
        }
        if (!this.state.inviteInfo) {
            errors.push({
                field: "fullName",
                error: "Sorry, your invitation is no longer valid",
            })
        } else if (this.state.inviteInfo.is_new_user) {
            if (state.fullName.trim().length < 4) {
                errors.push({
                    field: "fullName",
                    error: "Name is too short, please enter full name",
                })
            }
            const ret = this.validator.validate(state.password, { list: true })
            console.log("Password validation: " + ret)
            if (state.password !== state.password2) {
                errors.push({
                    field: "password",
                    error: "Passwords don't match, Enter the same password in both fields.",
                })
                errors.push({ field: "password2", error: "" })
            }
            if (ret.length > 0) {
                if (ret.includes("min")) {
                    errors.push({
                        field: "password",
                        error: "Password is too short (6 letters min)",
                    })
                }
                if (ret.includes("lowercase")) {
                    errors.push({
                        field: "password",
                        error: "Password should contain at least one letter [a-z]",
                    })
                }
            }
        }

        this.setState({ errors: errors })

        if (errors.length === 0) {
            let data = { invite_code: this.props.inviteCode }
            if (this.state.inviteInfo.is_new_user) {
                data.password = state.password
                data = Object.assign(data, fullName2FirstLast(state.fullName))
            }

            webApi
                .acceptInvite(this.props.inviteId, data)
                .then(() => {
                    statAdminEvent(
                        this.props.divisionId,
                        "accept-invite",
                        "member"
                    )
                    if (roles.length > 0) {
                        for (let role of roles) {
                            if (role.role) {
                                console.log("current_team_id", role.name)
                                localForage.setItem(
                                    "current_team_id",
                                    role.name
                                )
                            }
                        }

                        let update = []
                        for (let role of roles) {
                            if (role.role) {
                                update.push({
                                    user_id: this.props.userId,
                                    team_id: role.id,
                                    is_player: role.role === "player",
                                    is_coach: role.role === "coach",
                                    is_videographer: role.role === "manager",
                                })
                            }
                        }

                        webApi.batchUpdateTeamMembers(update).then(() => {
                            this.props.history.replace(
                                `/invite/${this.props.inviteId}/${this.props.inviteCode}/division/${this.props.divisionId}/fieldapp/alone`
                            )
                        })
                    } else {
                        this.props.history.replace(
                            `/invite/${this.props.inviteId}/${this.props.inviteCode}/division/${this.props.divisionId}/fieldapp/alone`
                        )
                    }
                })
                .catch(() => {
                    console.log(
                        "something went wrong while accepting the invitation"
                    )
                })
        }
    }

    onRolesUpdate(a, b) {
        console.log("onRolesUpdate:", a, b)
        let roles = Object.assign({}, this.state.roles)
        roles[a] = b

        this.setState({ roles })
    }
}

const mapStateToProps = (state, props) => {
    const divisionId = props.match.params.division_id
    const inviteId = props.match.params.invite_id
    const inviteCode = props.match.params.invite_code
    const userId = props.match.params.user_id
    return {
        divisionId,
        inviteId,
        inviteCode,
        userId,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        loadNav: () => {
            //dispatch(navAct.loadTeams("undefined"))
        },
        loadTeams: (divisionId, cb) => {
            dispatch(act.loadTeamsByDivision(divisionId, cb))
        },
        changeRoles: (divisionId, roles) => {
            dispatch(act.updateTeamMembers(divisionId, roles))
        },
    }
}

const MemberSetupContainer = withRouter(
    connect(mapStateToProps, mapDispatchToProps)(MemberSetup)
)

export default MemberSetupContainer
